import { RenderElementProps, useEditor, ReactEditor } from "slate-react"
import { Element, Node, Transforms, createEditor, Editor, Path } from "slate"
import React, { FC } from "react"
import { PhotoLayout } from "../photo/PhotoLayout"

export const EditorElement: FC<RenderElementProps> = (
  props: RenderElementProps
) => {
  const { attributes, children, element } = props

  const editor = useEditor()
  const onKeyDownOnImage = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.keyCode === 13) {
      const elementPath: Path = ReactEditor.findPath(editor, element)
      elementPath[0] = elementPath[0] + 1
      const node: Node = {
        type: "paragraph",
        children: [
          {
            text: ""
          }
        ]
      }
      Transforms.insertNodes(editor, node, { at: elementPath })
      /*
      elementPath[0] = elementPath[0] + 1
      const newPath: Path = [elementPath[0], 0]
      Transforms.deselect(editor)
      Transforms.setSelection(editor, newPath)
      Transforms.move(editor)
      */
    }
  }
  const onClickImagesLayer = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }

  switch (element.type) {
    case "images":
      return (
        <div
          {...attributes}
          onClick={onClickImagesLayer}
          onKeyDown={onKeyDownOnImage}
          contentEditable={false}
        >
          <PhotoLayout
            images={element.images}
            layout={element.layout}
            editable
          ></PhotoLayout>
        </div>
      )
    default:
      return (
        <p className="container bl-paragraph" {...attributes}>
          {children}
        </p>
      )
  }
}
